import { withSmallIcon } from './withSmallIcon';

export const hocs = {
    withSmallIcon,
};
